require('../modules/es6.parse-float');
module.exports = require('../modules/_core').parseFloat;



//////////////////
// WEBPACK FOOTER
// /Users/zhaolinxu/GitHub/IdleAnt/~/core-js/es6/parse-float.js
// module id = ../../../../core-js/es6/parse-float.js
// module chunks = 0